"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteFetch = void 0;
var tslib_1 = require("tslib");
var response_validator_1 = require("../error-handlers/response-validator");
var request_path_1 = require("../service/request-path");
var auth_suite_fetch_helper_1 = require("./auth-suite-fetch-helper");
var fetch_1 = require("./fetch");
var AuthSuiteFetch = /** @class */ (function (_super) {
    tslib_1.__extends(AuthSuiteFetch, _super);
    function AuthSuiteFetch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestPathService = request_path_1.requestPathAuthSuiteService;
        return _this;
    }
    AuthSuiteFetch.prototype.fetch = function (authSuiteFetchData) {
        return this.getPath(authSuiteFetchData)
            .then(function (getPathResult) {
            return fetch(getPathResult.path, auth_suite_fetch_helper_1.authSuiteFetchHelper.getRequestConfig(authSuiteFetchData, authSuiteFetchData.tokens));
        })
            .then(function (response) { return response_validator_1.responseValidator.validateResponse(response); });
    };
    return AuthSuiteFetch;
}(fetch_1.Fetch));
exports.authSuiteFetch = new AuthSuiteFetch();
